<template>
  <div
    class="sofa-card"
    :class="`${ isActive? 'active' :'' } ${type}`"
    @click="$emit('click')"
    :key="option.title"
  >
    <div class="sofa-card--thumb">
      <AppImage :lazy-src="imageUrl" />
    </div>
    <div class="sofa-card--name">{{ option.title }}</div>
  </div>
</template>
<script>
import AppImage from "./AppImage.vue";
export default {
  name: "ImageOptionCard",
  props: {
    option: Object,
    isActive: Boolean,
    type: String,
  },
  data() {
    return {
      imageUrl: this.setOptionImage(),
    };
  },
  components: {
    AppImage,
  },
  methods: {
    setOptionImage() {
      if (this.option.image_url) {
        return this.processURL("_80x80");
      }
      return "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=webp&v=1530129081";
    },
    processURL(processingString) {
      let fileExtension = ".JPG";
      if (this.option.image_url.match(/(.jpg)/)) {
        fileExtension = ".jpg";
      }
      if (!this.option.image_url.includes(processingString)) {
        return this.option.image_url.replace(
          /(.jpg)/i,
          `${processingString}${fileExtension}`
        );
      }
      return this.option.image_url;
    },
  },
};
</script>
<style scoped>
.sofa-card {
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  cursor: pointer;
  width: 90px;
  padding: 20px 4px;
  box-sizing: border-box;
}
.sofa-card--name {
  color: #3a3830;
  font-size: 14px;
  line-height: 140%;
  opacity: 0.87;
  text-align: center;
  user-select: none;
}
.sofa-card--thumb img {
  overflow: hidden;
  max-height: 54px;
  max-width: 54px;
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.sofa-card--thumb {
  min-height: 54px;
  min-width: 54px;
  max-width: 54px;
  max-height: 54px;
  overflow: hidden;
  margin: 0 auto 14px;
}
.sofa-card.leg .sofa-card--thumb{
  /* min-height: 83px;
  min-width: 34px;
  max-width: 34px;
  max-height: 83px; */
}
.sofa-card.leg .sofa-card--thumb img {
  width: 100%;
  height: 100%;
  max-height: unset;
  max-width: unset;
}
@media screen and (min-width: 768px) {
  .sofa-card--name {
    letter-spacing: 0.25px;
  }
}
.sofa-card.active {
  background: #F0F0F0;
}

.sofa-card.active .sofa-card--thumb {
  border: 0;
}
</style>
